import React, { Component } from "react";
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import Notifications from 'react-notification-system-redux';
import AmexDiningBranch from "./AmexDiningBranch";

class AMEXDiningBranchPublicPages extends Component {

    render() {
        let { notifications, match } = this.props; 
        return (
            <div className="container-fluid overflow-auto h-100 amex-dining-trainComponentBg ">
                <Switch>
                    <Route path="/amexdiningbranch/:id" component={AmexDiningBranch} />
                </Switch>
                <Notifications
                    notifications={notifications}
                />
            </div>
        );
    }
}

const mapStateToProp = state => ({
    user: state.user,
    notifications: state.notifications
});

export default connect(mapStateToProp)(AMEXDiningBranchPublicPages)

